// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================

export class SlidingNumericStepper extends EventTarget {
  constructor(focus = true, id = "sns", label = "x", value = 0, min = 0, max = 100, step = 1, jump = 10, fixed = 0, unit = "px", width=30, type = "number") {
    super();
    this.width = width;
    this.fixed = fixed;
    this.allowedKeys = "";
    this.specialKeys = ["Home", "End", "Backspace", "Delete", "Enter", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
    let hexSign = String(min).slice(0, 1) == "#" ? "#" : "";
    this._value = hexSign == "#" ? this.hex2Num(String(value).slice(1, 50)) : value;
    this._min = hexSign == "#" ? this.hex2Num(String(min).slice(1, 50)) : min;
    this._max = hexSign == "#" ? this.hex2Num(String(max).slice(1, 50)) : max;
    this._step = step;
    this._jump = jump;
    this._type = type;
    this.sns = document.createElement("div");
    this.sns.id = id;
    this._label = document.createElement("div");
    this._label.classList.add("snsLabel");
    this._input = document.createElement("input");
    this._input.setAttribute("select", true);
    this._input.classList.add("snsInput");
    this._input.style.width = width + "px";
    this._unit = document.createElement("div");
    this._unit.style.userSelect = "none";
    this._unit.classList.add("snsUnit");
    this.sns.classList.add("sns");
    this.sns.appendChild(this._label);
    let hexSymbol;
    if (hexSign == "#") {
      this.allowedKeys = "0123456789ABCDEFabcdef";
      hexSymbol = document.createElement("div");
      hexSymbol.style.marginLeft = "5px";
      hexSymbol.innerHTML = "#";
      this.sns.appendChild(hexSymbol);
    } else {
      this.allowedKeys = "0123456789.-";
    }
    this.sns.appendChild(this._input);
    this.sns.appendChild(this._unit);

    if (label != "") {
      this._label.innerHTML = label + ":";
    } else {
      this._label.style.display = "none";
    }    
    // this._input.style.width = (max.length + 4) * 21 + "px";
    this._input.value = value.toFixed(fixed);
    this._val = null;
    var mousedn = false;
    var downAt;
    if (hexSign == "#") {
      this._input.value = String(value).slice(1, 10);
      let span = document.createElement("span");
      span.style.visibility = "hidden";
      span.style.position = "absolute";
      document.body.appendChild(span);
      span.textContent = "8".repeat(6);
      span.classList.add("snsInput");
      let font = window.getComputedStyle(span).fontFamily;
      let color = window.getComputedStyle(span).color;
      span.classList.remove("snsInput");
      hexSymbol.style.color = color;
      // this._input.style.width = span.offsetWidth + 6 + "px"; // Add some padding
      // this._input.style.width = "30px"; // Add some padding
        this._input.maxLength = 6;
      this._input.style.marginLeft = 0;
      document.body.removeChild(span);
    } else {
      this.updateInputWidth(min, max, step,fixed, type);
    }
    this._input.style.outline = "none";    
    this._input.width = this.width;
    this._input.classList.add("snsInput");
    this._input.draggable = false;
    if (unit != "") {
      this._unit.innerHTML = unit;
    } else {
      this._unit.style.display = "none";
    }
    this._focus = false;
    this.shiftDown = false;
    this._input.addEventListener("keydown", (e) => this.onKeyDown(e), false);
    this._input.addEventListener("keyup", (e) => this.onKeyUp(e), false);
    this._input.addEventListener(
      "mousedown",
      (e) => {
        e.target.focus();
        var event = new CustomEvent("FOCUS", {});
        this.dispatchEvent(event);
        document.documentElement.classList.add("snsCustomCursor");
        this.val = this._type == "number" ? Number(this._input.value) : this.hex2Num(this._input.value);
        downAt = e.screenX;
        mousedn = true;
      },
      false
    );
    window.addEventListener("resize", ()=>{
      if(window.innerWidth<window.innerHeight){
        // this._input.
      }
    })
    document.addEventListener(
      "mousemove",
      (e) => {
        e.preventDefault();
        if (mousedn) {
          var dir = e.screenX > downAt ? 1 : -1;
          downAt = e.screenX;
          if (e.shiftKey) {
            this.val += this._jump * dir;
          } else {
            this.val += this._step * dir;
          }
          if (this.val >= this._max) {
            this.val = this._max;
            downAt = e.screenX;
          } else if (this.val <= this._min) {
            this.val = this._min;
            downAt = e.screenX;
          }
          this.setvalueLocal(this._type == "hex" ? this.num2Hex(this.val) : this.val);
        }
      },
      false
    );
    document.addEventListener("mouseup", (e) => {
      e.preventDefault();
      mousedn = false;
      document.documentElement.classList.remove("snsCustomCursor");
    });
  }
  hex2Num(v) {
    return parseInt(v, 16);
  }
  num2Hex(v) {
    v = parseInt(v).toString(16);
    let zeros = "000000";
    let k = zeros.slice(0, 6 - v.length) + v;
    return k.toUpperCase();
  }
  snsFocus(v) {
    this._input.style.color = v ? "#0000FF" : "#666666";
    this._focus = v;
  }
  onKeyDown(e) {
    let key = e.key;
    if (!this.allowedKeys.includes(key) && !this.specialKeys.includes(key)) {
      e.preventDefault();
    } else {
      let v = 0;
      this.shiftDown = e.shiftKey;
      if (this._type == "number") {
        v = Number(this._input.value);
      } else if (this._type == "hex") {
        v = this.hex2Num(this._input.value);
      }
      if (e.key == "ArrowUp") {
        v += this.shiftDown ? this._jump : this._step;
        if (v > this._max) {
          v = this._max;
        }
        this.setvalueLocal(this._type == "hex" ? this.num2Hex(v) : v);
      } else if (e.key == "ArrowDown") {
        v -= this.shiftDown ? this._jump : this._step;
        if (v < this._min) {
          v = this._min;
        }
        this.setvalueLocal(this._type == "hex" ? this.num2Hex(v) : v);
      } else if (e.key == "Enter") {
        if (v < this._min) {
          v = this._min;
        } else if (v > this._max) {
          v = this._max;
        }
        this.setvalueLocal(this._type == "hex" ? this.num2Hex(v) : v);
        this._input.blur();
      }
    }
  }
  onKeyUp(e) {
    let key = e.key;
    if (!this.allowedKeys.includes(key) && !this.specialKeys.includes(key)) {
      e.preventDefault();
    } else {
      this._input.value = this._input.value.toUpperCase();
      let v = 0;
      this.shiftDown = e.shiftKey;
      if (this._type == "number") {
        v = Number(this._input.value);
      } else if (this._type == "hex") {
        v = this.hex2Num(this._input.value);
      }
    }
  }
  setvalueLocal(v) {
    if (this._type == "number") {
      this._input.value = v.toFixed(this.fixed);
    } else if (this._type == "hex") {
      this._input.value = v;
    }
    var event = new CustomEvent("VALUE_CHANGE", { detail: { id: this.sns.id, value: v } });
    this.dispatchEvent(event);
  }
  updateInputWidth(min, max, step, fixed, type) {
    let span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.position = "absolute";
    document.body.appendChild(span);
    let str = "";
    let m;
    if (type == "number") {
      if (Number.isInteger(step)) {
        m = Math.max(String(min).length, String(max).length);
        str = "8".repeat(m + fixed-1);
      } else {
        let decimalPart = String(step).split(".")[1];
        m = Math.max(String(min).length, String(max).length);
        m = m + decimalPart.length + 1;
        str = "8".repeat(m + 2);
      }
    }
    span.textContent = str;
    span.style.font = window.getComputedStyle(this._input).font;
    // this._input.style.width = (span.offsetWidth + 10) + 'px'; // Add some padding
    // this._input.style.width = (span.offsetWidth - 20 ) + "px"; // Add some padding
    // this._input.classList.add("snsInput");
    this._input.maxLength = m;
    document.body.removeChild(span);
  }
  appendTo(parent) {
    if (parent instanceof HTMLElement) {
      parent.appendChild(this.sns);
    } else {
      console.error("Invalid parent element. It must be an HTMLElement.");
    }
  }
  updateSNSExternal(e) {
    this.onKeyDown(e);
  }
  focus() {
    this._input.focus();
  }
  get value() {
    if (this.hexSign == "#") {
      return this._input.value;
    } else {
      return Number(this._input.value);
    }
  }
  set value(v) {
    this._input.value = v;
  }
}
